import React, { useState, useEffect } from "react";

import { PageStandard } from "components/admin/PageStandard";
import { CreateACForm } from "components/automation/CreateACForm";
import { useUserContext } from "contexts/UserContext";
import { DeviceType } from "api/onboardingTypes";
import { AcModel, AcProperties } from "api/automationTypes";
import { fetchACModels, fetchACTypes } from "api/onboarding";
import { useParams } from "react-router-dom";
import { Button, Divider } from "@mui/material";
import { BlockStandard } from "components/admin/BlockStandard";
import { createACs } from "api/devices";
import { useSetError } from "contexts/ErrorContext";
import { CustomCodes } from "contexts/ErrorContextData";
import { RoomSelector } from "components/selectors/RoomSelector";

export const CreateAC = () => {
  const { token, currentSpace, currentEnvironment } = useUserContext();
  // @ts-expect-error react-router doesn't type params
  const { environmentId } = useParams();

  const [acOptions, setACOptions] = useState<DeviceType[]>([]);
  const [acModels, setACModels] = useState<AcModel[]>([]);

  const [acList, setAcList] = useState<AcProperties[]>([
    {
      airName: "",
      type: undefined,
      model: undefined,
      id: "1",
      maintenanceState: undefined,
      workingHours: undefined,
    },
  ]);
  const setGlobalError = useSetError();

  useEffect(() => {
    const getTypesList = async () => {
      try {
        const data = await fetchACTypes(token);
        setACOptions(data || []);
      } catch (error) {
        // @ts-expect-error
        setGlobalError(error.response?.data?.error);
      }
    };
    getTypesList();
  }, [token, setGlobalError]);

  useEffect(() => {
    const getTypesList = async () => {
      try {
        const data = await fetchACModels(token);
        setACModels(data);
      } catch (error) {
        // @ts-expect-error
        setGlobalError(error.response?.data?.error);
      }
    };
    getTypesList();
  }, [token, setGlobalError]);

  const handleChange = (changedAc) => {
    setAcList((prevList) =>
      prevList.map((item) => {
        if (item.id === changedAc.id) {
          return changedAc;
        } else {
          return item;
        }
      })
    );
  };

  const handleSubmit = async () => {
    const validACs = acList
      .filter((device) => device.airName)
      .map(({ id, procelBadge, inmetro, power, amount, ...ac }) => ({
        ...ac,
        Inmetro: inmetro,
        Power: power,
        Quantity: amount,
      }));
    if (validACs.length) {
      try {
        await createACs(
          token,
          currentSpace?.id || "",
          environmentId || currentEnvironment?.id,
          acList
        );
      } catch (error) {
        // @ts-expect-error
        setGlobalError(error.response?.data?.error);
      }
    } else {
      setGlobalError(CustomCodes.INCOMPLETE_FORM);
    }
  };

  const addAc = () => {
    setAcList((prevList) => [
      ...prevList,
      {
        airName: "",
        type: undefined,
        model: undefined,
        id: `${prevList.length + 1}`,
        eficiency: "",
        maintenanceState: undefined,
        workingHours: undefined,
      },
    ]);
  };

  return (
    <PageStandard title="Ares-condicionados" onAdd={addAc}>
      <RoomSelector />
      {acList.map((acData, pos) => (
        <>
          <CreateACForm
            key={acData.id}
            acData={acData}
            acOptions={acOptions}
            acModels={acModels}
            onChange={handleChange}
          />
          {acList.length > 1 && pos + 1 < acList.length && <Divider />}
        </>
      ))}

      <BlockStandard hideDivider>
        <Button variant="contained" onClick={handleSubmit}>
          Salvar ar-condicionado
        </Button>
      </BlockStandard>
    </PageStandard>
  );
};
